import {
    ERequestsAndOperationsActions,
    RequestsAndOperationsActions
} from "@edp-store/actions/requests-and-operations.actions";
import {
    initialRequestsAndOperationsState,
    IRequestsAndOperationsState
} from "@edp-store/state/requests-and-operations.state";

export function requestsAndOperationsReducers(
    state = initialRequestsAndOperationsState,
    action: RequestsAndOperationsActions
): IRequestsAndOperationsState {
    switch (action.type) {
        case ERequestsAndOperationsActions.SetRequestsAndOperations: {
            return {
                ...state,
                requestsAndOperations: action.payload
            };
        }
        case ERequestsAndOperationsActions.SetAvailableTimeSlots: {
            return {
                ...state,
                availableTimeSlots: {
                    data: action.payload,
                    lastAPIError: null
                }
            };
        }
        case ERequestsAndOperationsActions.AvailableTimeSlotsAPIError: {
            return {
                ...state,
                availableTimeSlots: {
                    ...state.availableTimeSlots,
                    lastAPIError: action.error
                }
            };
        }
        case ERequestsAndOperationsActions.SetFilters: {
            return {
                ...state,
                filters: action.payload
            };
        }
        case ERequestsAndOperationsActions.SetServices: {
            return {
                ...state,
                services: action.payload
            };
        }
        case ERequestsAndOperationsActions.SetLoadedServices: {
            return {
                ...state,
                loadedServices: action.payload,
            };
        }
        case ERequestsAndOperationsActions.SetLoadedSlots: {
            return {
                ...state,
                loadedSlots: action.payload,
            };
        }
        case ERequestsAndOperationsActions.SetLoadedRequestsAndOperations: {
            return {
                ...state,
                loadedRequestsAndOperations: action.payload,
            };
        }
        case ERequestsAndOperationsActions.SetLocalSupportList: {
            return {
                ...state,
                localSupportList: action.payload,
            };
        }
        case ERequestsAndOperationsActions.SetAssociatedContract: {
            return {
                ...state,
                associatedContract: action.payload,
            };
        }
        case ERequestsAndOperationsActions.SetRequestsAndOperationsDetails: {
            return {
                ...state,
                selectedRequest: action.payload,
            };
        }
        case ERequestsAndOperationsActions.SetSelectedServiceAndMotive: {
            return {
                ...state,
                selectedServiceAndMotive: action.payload,
            };
        }
        case ERequestsAndOperationsActions.SetNewRequestStatus: {
            return {
                ...state,
                newRequestStatus: action.payload,
            };
        }
        case ERequestsAndOperationsActions.SetMotiveId: {
            return {
                ...state,
                selectedServiceAndMotive: {
                    ...state.selectedServiceAndMotive,
                    motiveId: action.payload,
                }
            };
        }
        default: {
            return state;
        }
    }
}
